import React from 'react';

const ProdactDetailLoader = () => {
    return (
        <div>
            <div className='container mx-auto animate-pulse py-5'>
                <p className='bg-slate-200 text-slate-200 py-2'>Loding</p>
                <div className='over overflow-hidden'>
                    <div className='main pt-2 pb-5 grid justify-center content-center md:grid-cols-5 grid-cols-1 gap-5'>
                        <div className='md:col-span-2 md:px-4'>
                            <div className='bg-slate-200 text-slate-200 h-60 w-full' />
                            <div className="grid gap-2 grid-cols-4 mt-2">
                                <div className='h-28 w-full bg-slate-200 text-slate-200 '>01</div>
                                <div className='h-28 w-full bg-slate-200 text-slate-200 '>02</div>
                                <div className='h-28 w-full bg-slate-200 text-slate-200 '>03</div>
                                <div className='h-28 w-full bg-slate-200 text-slate-200 '>04</div>
                            </div>
                        </div>
                        <div className='md:col-span-3 md:px-4'>
                            <div>
                                <h1 className='bg-slate-200 text-slate-200 my-2'>Loading...</h1>
                                <p className='bg-slate-200 text-slate-200 my-2'>Loading...</p>
                                <p className='bg-slate-200 text-slate-200 my-2'>Loading...</p>
                                <p className='bg-slate-200 text-slate-200 my-2'>Loading...</p>
                                <p className='bg-slate-200 text-slate-200 my-2'>Loading...</p>
                                <p className='bg-slate-200 text-slate-200 my-2'>Loading...</p>
                                <p className='bg-slate-200 text-slate-200 my-2'>Loading...</p>
                                <p className='bg-slate-200 text-slate-200 my-2'>Loading...</p>
                                <p className='bg-slate-200 text-slate-200 my-2'>Loading...</p>
                                <p className='bg-slate-200 text-slate-200 my-2'>Loading...</p>
                                <p className='bg-slate-200 text-slate-200 my-2'>Loading...</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    {/* <Relaated productCategory={product.category} /> */}
                </div>
            </div>
        </div>
    );
};

export default ProdactDetailLoader;